import React from 'react';
import clsx from 'clsx';

import { SidebarHeader } from '@core/ProSidebar/components/SidebarHeader';
import { Sidebar } from '@core/ProSidebar';
import SidebarMenu from '@/layouts/AppLayout/SidebarMenu';

import { useLayout } from '@/context/AppAuthContext';

import { hexToRgba } from '@/layouts/AppLayout/utils/helpers';
import { themes } from '@/layouts/AppLayout/utils/constants';

export const AppLayoutAsideNew = ({ children }: { children?: React.ReactNode }): JSX.Element => {
  const { setToggled, setBroken, collapsed, toggled, rtl, hasImage, theme } = useLayout();

  return (
    <div className="flex h-screen max-h-screen w-screen">
      <Sidebar
        collapsed={collapsed}
        toggled={toggled}
        onBackdropClick={() => setToggled(false)}
        onBreakPoint={setBroken}
        rtl={rtl}
        breakPoint="md"
        backgroundColor={hexToRgba(themes[theme].sidebar.backgroundColor, hasImage ? 0.9 : 1)}
        rootStyles={{ color: themes[theme].sidebar.color }}
      >
        <div
          className={clsx(
            'flex h-full flex-col bg-[#343a40] text-white',
            collapsed && 'items-center justify-center',
          )}
        >
          <SidebarHeader collapsed={collapsed} />
          <SidebarMenu />
        </div>
      </Sidebar>
      {children}
    </div>
  );
};
